module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Grand Prime Black.c7434b78.png";